.current-screen-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: var(--bg-color, lightgrey);
  background-image: var(--bg-img,);
}

.next-screen-background {
  display: none;
  background-image: var(--bg-next-img,);
}

.is-mobile-viewport.current-screen-background {
  background-color: var(--bg-color, grey);
  background-image: var(--bg-img);
}
